import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { TSubsectionClickEventProps } from '@/_analytic/events/subsection-click-event/_types';

export const subsectionClickEvent = (params: TSubsectionClickEventProps) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.SUBSECTION_CLICK,
    params,
  });
};
